import { gql } from "urql";
export const GetEmailPreferencesQuery = gql `
    query GetEmailPreferences($key1: String!, $key2: String!) {
        emailPreferences {
            emailPreferences(key1: $key1, key2: $key2) {
                emailPreferenceId
                emailPreferenceType
                shouldSend
            }
        }
    }
`;
